export default __webpack_public_path__ + "static/media/qr_codereview.ac85688a.svg";